import {
  useRochamboStore,
  useSessionStore,
} from "@/stores";
import type {
  RochamboMatch,
  RochamboPick,
} from "@/types";

const PICKS = new Set(["rock", "paper", "scissors"]);

function readPick(value: unknown): RochamboPick | null {
  return typeof value === "string" && PICKS.has(value)
    ? (value as RochamboPick)
    : null;
}

/** Sanitize the duel broadcast by the storyteller before applying it */
function readMatch(params: unknown): RochamboMatch | null {
  if (!params || typeof params !== "object") return null;
  const { id, players, submitted, picks, revealed } = params as Record<
    string,
    unknown
  >;
  if (typeof id !== "number") return null;
  if (!Array.isArray(players) || players.length !== 2) return null;
  if (typeof players[0] !== "number" || typeof players[1] !== "number")
    return null;
  const submittedFlags = Array.isArray(submitted) ? submitted : [];
  const sentPicks = Array.isArray(picks) ? picks : [];
  return {
    id,
    players: [players[0], players[1]],
    submitted: [!!submittedFlags[0], !!submittedFlags[1]],
    picks: [readPick(sentPicks[0]), readPick(sentPicks[1])],
    revealed: !!revealed,
  };
}

export function handleRochambo(params: unknown) {
  const session = useSessionStore();
  if (!session.isPlayerOrSpectator) return;
  useRochamboStore().setMatch(readMatch(params));
}
